import React from 'react'
import st from './DatePickerWrapper.module.scss'

const DatePickerWrapper = ({ children }) => {
  return <div className={st.wrapperDatePicker}>{children}</div>
}

export default DatePickerWrapper
